import { types, flow, Instance } from 'mobx-state-tree';
import {
  SettingsGroupModel,
  ISettingsGroupModel,
  EndUserSettingModel,
  EndUserKeyModel,
  AttributeModel,
  IAttributeModel,
} from './models';
import { Setting, SettingsGroup, PutSettingsData } from './types';
import { AxiosResponse } from 'axios';
import axios from 'server';
const { model, array, maybeNull } = types;

export const EndUserSettingsFormStore = model('EndUserSettingsFormStore', {
  groupedUserNamePolicies: array(SettingsGroupModel),
  groupedPasswordPolicies: array(SettingsGroupModel),
  groupedGeneralSettings: array(SettingsGroupModel),
  endUserConfigSettings: maybeNull(EndUserSettingModel),
  attributeKey: array(AttributeModel),
  endUserconfigKeyModel: array(EndUserKeyModel),
  clickedKey: maybeNull(EndUserKeyModel),
})
  .views((self) => ({
    settingsByTypeView(type: 'user-name' | 'password' | 'general' | 'policy'): ISettingsGroupModel[] {
      switch (type) {
        case 'user-name':
          return self.groupedUserNamePolicies;
        case 'password':
          return self.groupedPasswordPolicies;
        case 'policy':
          return [...self.groupedUserNamePolicies, ...self.groupedPasswordPolicies];
        default:
          return self.groupedGeneralSettings;
      }
    },

    getShift(type: 'user-name' | 'password' | 'general' | 'policy', groupIndex: number): number {
      let policies: ISettingsGroupModel[] = [];
      switch (type) {
        case 'user-name':
          policies = self.groupedUserNamePolicies;
          break;
        case 'password':
          policies = self.groupedPasswordPolicies;
          break;
        case 'policy':
          policies = [...self.groupedUserNamePolicies, ...self.groupedPasswordPolicies];
          break;
        default:
          policies = self.groupedGeneralSettings;
          break;
      }
      let shift = 0;
      for (let i = 0; i < groupIndex; i++) {
        shift += policies[i].settings.length;
      }
      return shift;
    },
  }))
  .actions((self) => ({
    normalizePoliciesGroups: ({ data: { data } }: AxiosResponse<{ data: Setting[] }>): void => {
      const usernamePolicy: SettingsGroup[] = [];
      const passwordPolicy: SettingsGroup[] = [];
      const general: SettingsGroup[] = [];
      if (data && Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          // eslint-disable-next-line
          const existGroupIndex = (eval(data[i].sectionKey) as SettingsGroup[]).findIndex(
            ({ name }) => name === data[i].groupName
          );
          if (existGroupIndex !== -1) {
            // eslint-disable-next-line
            (eval(data[i].sectionKey) as SettingsGroup[])[existGroupIndex].settings.push(data[i]);
          } else {
            // eslint-disable-next-line
            (eval(data[i].sectionKey) as SettingsGroup[]).push({ name: data[i].groupName, settings: [data[i]] });
          }
        }
      }
      self.groupedUserNamePolicies.replace(usernamePolicy as ISettingsGroupModel[]);
      self.groupedPasswordPolicies.replace(passwordPolicy as ISettingsGroupModel[]);
      self.groupedGeneralSettings.replace(general as ISettingsGroupModel[]);
      //return self.groupedUserNamePolicies;
    },
    normalizeattitudeSettingsget({ data }: AxiosResponse): IAttributeModel[] {
      if (data?.data && Array.isArray(data.data)) {
        self.attributeKey.replace(data.data);
      }
      return self.attributeKey;
    },
    normalizeportalSettingsget({ data }: AxiosResponse) {
      self.endUserConfigSettings = data;
      localStorage.setItem('endUserConfigSettings', JSON.stringify(self.endUserConfigSettings));
      return self.endUserConfigSettings;
    },

    normalizekeySettingget({ data }: AxiosResponse) {
      const apiData = data.data;
      if (apiData && Array.isArray(apiData)) {
        const transformedKeys = apiData.map((item: any) => ({
          id: item.client_id,
          created_at: item.created_at || new Date().toISOString(),
          client_secret: item.client_secret || '',
          name: item.name,
          expires_at: item.expires_at || null,
          expiry_date: item.expiry_date || item.expires_at || null,
          client_id: item.client_id,
          grant_types: item.grant_types,
        }));
        self.endUserconfigKeyModel.replace(transformedKeys);
      }

      return self.endUserconfigKeyModel;
    },
    setclickedKey(client_id: string): void {
      const foundKey = self.endUserconfigKeyModel.find((key) => key.client_id === client_id);
      if (foundKey) {
        self.clickedKey = {
          id: foundKey.id,
          created_at: foundKey.created_at,
          client_secret: foundKey.client_secret,
          name: foundKey.name,
          expires_at: foundKey.expires_at,
          expiry_date: foundKey.expiry_date,
          client_id: foundKey.client_id,
          grant_types: foundKey.grant_types,
        };
      } else {
        self.clickedKey = null;
      }
    },
    clearSelected(): void {
      self.clickedKey = null;
    },
  }))
  .actions((self) => ({
    getSettings: flow(function* () {
      const result = yield axios
        .get('settings/user-settings')
        .then(self.normalizePoliciesGroups)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    getSetting: flow(function* () {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      const domain = parts.length > 1 && hostname !== 'localhost' ? parts[0] : '';

      const result = yield axios
        .get(`no-auth-user-settings?domain=${domain}`)
        .then(self.normalizePoliciesGroups)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    updateSettings: flow(function* (data: PutSettingsData) {
      const result = yield axios
        .put('settings/user-settings', data)
        .then()
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    portalSettings: flow(function* (data: any) {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (key === 'data') {
          return formData.append(key, JSON.stringify(data[key]));
        } else formData.append(key, data[key]);
      });
      const result = yield axios
        .post('settings/alerts', formData)
        .then(self.normalizePoliciesGroups)
        .catch((error) => {
          if (error.response.status === 422) {
            const arr: any = Object.values(error.response.data.errors)[0];
            throw new Error(arr[0]);
          }
          throw new Error(error.response.data.data.message);
        });
      return result;
    }),
    // portalSettingsget: flow(function* (data: any) {

    //   const result = yield axios
    //     .get('admin/alert')
    //     .then((res) => {
    //       console.log(res)
    //     })
    //     .catch((error) => {
    //       console.log(error.response)
    //       throw new Error(error);
    //     });
    //   return result;
    // }),
    portalSettingsget: flow(function* () {
      const result = yield axios
        .get<any>('settings/alerts')
        .then(self.normalizeportalSettingsget)
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }),

    getPortalSettings: flow(function* () {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      const domain = parts.length > 1 && hostname !== 'localhost' ? parts[0] : '';
      const result = yield axios
        .get<any>(`/settings/login-alert?domain=${domain}`)
        .then(self.normalizeportalSettingsget)
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }),

    ldapKeyGenrate: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`/oauth/password/regenerate-secret`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),

    OauthKeyGenrate: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`/oauth/regenerate-secret`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),

    UserIdGenrate: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`settings/alerts/user-id`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),

    UserIPGenrate: flow(function* (data: any) {
      let indexValue = '0';
      const result = yield axios
        .post<any>(`settings/alerts/ip-address`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errorKeys = Object.keys(error.response.data.errors);
            if (errorKeys.length > 0 && errorKeys[0].startsWith('ipAddress.')) {
              indexValue = errorKeys[0].substring('ipAddress.'.length);
            }
            if (error.response.data.errors[`ipAddress.${indexValue}`]) {
              const errorMessage = error.response.data.errors[`ipAddress.${indexValue}`][0];
              throw new Error(errorMessage);
            }
          }
          const errorMessage = 'Duplicate IpAddress not allowed';
          throw new Error(errorMessage);
        });
      return result;
    }),
    endUserDownloadLinkPost: flow(function* () {
      const result = yield axios
        .post<any>(`/generatePublicPrivateKeys`, '')
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    getldapKeyGenrate: flow(function* (id: any) {
      const result = yield axios
        .get<any>(`/oauth/all-credentials`)
        .then(self.normalizekeySettingget)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    // oauth/password/credentials
    // oauth/credentials
    getPasswordKeyGenrate: flow(function* (id: any) {
      const result = yield axios
        .get<any>(`oauth/password/credentials`)
        .then(self.normalizekeySettingget)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    getOauthKeyGenrate: flow(function* (id: any) {
      const result = yield axios
        .get<any>(`/oauth/credentials`)
        .then(self.normalizekeySettingget)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    deleteLdapKeyGenrate: flow(function* (id: any) {
      const result = yield axios
        .delete<any>(`/oauth/client`, {
          data: {
            grant_type: self.clickedKey?.grant_types,
          },
        })
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    attributeget: flow(function* () {
      const result = yield axios
        .get<any>('settings/custom-attributes')
        .then(self.normalizeattitudeSettingsget)
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }),
    CustomAttributeget: flow(function* () {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      const domain = parts.length > 1 && hostname !== 'localhost' ? parts[0] : '';
      const result = yield axios
        .get<any>(`no-auth-get-custom-attribute?domain=${domain}`)
        .then(self.normalizeattitudeSettingsget)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    AttributeGenrate: flow(function* (data: any) {
      const result = yield axios
        .post<any>(`settings/custom-attributes`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    UpdateAttribute: flow(function* (data: any) {
      const result = yield axios
        .put<any>(`settings/custom-attributes/test`, data)
        .then((response) => {
          return response.data.message;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    deleteattribute: flow(function* (payload) {
      try {
        yield axios.delete(`settings/custom-attributes/delete`, {
          data: payload,
        });
      } catch (error: any) {
        throw new Error(error);
      }
    }),
  }));

export type IEndUserSettingsFormStore = Instance<typeof EndUserSettingsFormStore>;
